import cancel from './cancel'
import edit from './edit'
import post from './post'
import getTags from './getTags'
import getCurrentWebcastUrl from './getCurrentWebcastUrl'
import cancelWebcast from './cancelWebcast'

export default {
  cancel,
  edit,
  post,
  getTags,
  getCurrentWebcastUrl,
  cancelWebcast
}
